import { Box, type BoxProps, Typography, type TypographyProps } from "@mui/material";

// Centralized strings for internationalization
const tEmpty = "Nothing to show here";

export interface EmptyStateProps {
  message?: string;
  slotProps?: {
    container?: BoxProps;
    message?: TypographyProps;
  };
}

export const EmptyState = ({ message, slotProps }: EmptyStateProps) => {
  return (
    <Box
      {...slotProps?.container}
      sx={{ display: "grid", gridAutoFlow: "row", placeContent: "center", ...slotProps?.container?.sx }}
    >
      <Typography {...slotProps?.message}>{message ?? tEmpty}</Typography>
    </Box>
  );
};
